globalThis.backoffice = globalThis.backoffice || {};

backoffice.WebsiteMigrationStatusesUpdater = (function()
{
  function WebsiteMigrationStatusesUpdater($scrapping_statuses) {
    if($scrapping_statuses.length && $scrapping_statuses.hasClass('scrapping-status-processing')) {
      this.ajax_path = $scrapping_statuses.data('ajax-reload-path');
      this.autoReloadStatuses();
    }
  }

  WebsiteMigrationStatusesUpdater.prototype = {
    reloadStatuses: function(){
      var me = this;

      $.ajax({
        url: me.ajax_path,
        method: "GET",
        success: function(data){
          if(data.scrapping_statuses) {
            var $scrapping_statuses = $(data.scrapping_statuses);

            if(!$scrapping_statuses.hasClass('scrapping-status-processing')) {
              clearInterval(me.interval);
              me.interval = null;
            }

            $('.sidebar-category.scrapping-statuses').replaceWith($scrapping_statuses);
          }
        }
      });
    },
    autoReloadStatuses: function(){
      var me = this;
      var interval;

      if(!this.interval) {
        this.interval = setInterval(me.reloadStatuses.bind(this), 2000);
      }
    }
  }

  return WebsiteMigrationStatusesUpdater;
})();
